import { requestApi } from '../util/network'
// 用户登录
export const login =
    (userName, password, pictureCode = '') =>
      requestApi(
        '/Login/index',
        'POST',
        {
          'username': userName,
          'password': password,
          'captcha': pictureCode,
          'client_type': 'wap'
        }
      )
// 用户微信登录
export const wechatLogin =
    (ref, inviterId,clear,type,appintment,member_id,live_apply_id,live_apply_play_time) =>
      requestApi(
        '/Wxauto/login',
        'GET',
        {
          'ref': ref,
          'inviter_id': inviterId,
          'clear':clear,
          'type':type,
          'appintment':appintment,
          'member_id':member_id,
          'live_apply_id':live_apply_id,
          'live_apply_play_time':live_apply_play_time
        }
      )
// 用户手机登录
export const LoginByMobile =
    (phone, captcha) =>
      requestApi(
        '/Connect/sms_login',
        'POST',
        {
          'usermobile': phone,
          'mobilecode': captcha,
          'client': 'wap'
        }
      )
// 绑定
export const bind =
    (type, from, openid, unionid, nickname, headimgurl, user, password, password2, inviter_id) =>
      requestApi(
        '/Login/bind',
        'POST',
        {
          type: type,
          from: from,
          openid: openid,
          unionid: unionid,
          nickname: nickname,
          headimgurl: headimgurl,
          user: user,
          password: password,
          password2: password2,
          inviter_id: inviter_id,
          client_type: 'wap'
        }
      )
export const getThirdLogin =
    () =>
      requestApi(
        '/Login/third_login',
        'POST'

      )
